import { omit } from 'remeda';
import { isQuestionItem } from '../../state-type-guards';
import type { StoreState } from '../../state-types';
import { makeSurveyDirty } from '../utils/make-survey-dirty';

/** Delete an answer from a card. */
export const deleteAnswer =
    (cardId: string, answerId: string) =>
    (state: StoreState): StoreState => {
        const card = state.actions.getCard(cardId);
        if (!card) {
            throw new Error('Card not found');
        }

        // Ensure it's a question card
        if (!isQuestionItem(card)) {
            throw new Error('Only Question Cards can have Answers.');
        }

        const removeIndex = card.answerIds.indexOf(answerId);
        if (removeIndex === -1) {
            throw new Error('Answer not found');
        }

        const answerIds = [
            ...card.answerIds.slice(0, removeIndex),
            ...card.answerIds.slice(removeIndex + 1),
        ];

        return makeSurveyDirty({
            ...state,
            // remove answer id from card
            cards: {
                ...state.cards,
                [cardId]: {
                    ...card,
                    answerIds,
                },
            },
            // remove answer from answers collection
            answers: omit(state.answers, [answerId]),
        });
    };
